import { render, staticRenderFns } from "./_base-sidebar.vue?vue&type=template&id=c1335ec4&scoped=true&"
import script from "./_base-sidebar.vue?vue&type=script&lang=js&"
export * from "./_base-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./_base-sidebar.vue?vue&type=style&index=0&id=c1335ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1335ec4",
  null
  
)

export default component.exports